var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inMaintenance)?_c('div',{staticClass:"maintenance"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('maintenance.serviceDisruption')))]),_c('p',{staticClass:"body"},[_vm._v(_vm._s(_vm.$t('maintenance.message', {dateStart: _vm.dateStart, duration: _vm.duration})))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }